import * as tagSelectorAction from './tagSelectorAction';
import * as industryAction from './industryActions';
import * as navigationAction from './navigationActions';
import * as purposeAction from './purposeActions';
import * as businessIdeaActions from './businessIdeaActions';
import * as namesListActions from './namesListActions';
import * as selectedNameActions from './selectedNameActions';

export default ({
  
  ...industryAction,
  ...tagSelectorAction,
  ...navigationAction,
  ...purposeAction,
  ...businessIdeaActions,
  ...namesListActions,
  ...selectedNameActions
});
